import { z } from "zod";

export const regionCreateSchema = z.object({
  name: z.string().min(1, "Name is required"),
  cityId: z.string().min(1, "City is required"),
});

export const regionUpdateSchema = z.object({
  name: z.string().min(1, "Name is required").optional(),
  cityId: z.string().min(1, "City is required").optional(),
});

export type RegionFormData = z.infer<typeof regionCreateSchema>;
export type RegionUpdateFormData = z.infer<typeof regionUpdateSchema>;

export interface RegionCity {
  id: string;
  name: string;
}

export interface RegionScreen {
  id: string;
  screenName: string;
}

export interface Region {
  id: string;
  name: string;
  cityId: string;
  city?: RegionCity;
  tenantId?: string;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
  screens: RegionScreen[];
}

export interface RegionsResponse {
  regions: Region[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface RegionFilters {
  page?: number;
  pageSize?: number;
  search?: string;
  cityId?: string;
}

export interface RegionRequest {
  name: string;
  cityId: string;
}

export interface UpdateRegionPayload {
  id: string;
  region: RegionUpdateFormData;
}
